<template>
  <span class="source-with-count">
    <i
      :class="icon"
      class="d-flex justify-content-center align-items-center icon"
    ></i>
    <span class="text-grey-desc fs-12">{{ formattedCount }}</span>
  </span>
</template>

<script>
export default {
  name: 'SourceWithCount',
  props: {
    source: String,
    count: Number
  },
  computed: {
    icon() {
      const source = this.source
      if (source === 'twitter') {
        return `fab fa-x-twitter social-x-twitter`
      } else if (source === 'pantip') {
        return `fas fa-comment social-pantip`
      } else if (source === 'website') {
        return `fas fa-globe social-website`
      } else if (source === 'facebook') {
        return `fab fa-facebook-f social-facebook`
      } else if (source === 'instagram') {
        return `fab fa-instagram social-instagram`
      } else if (source === 'tiktok') {
        return `fab fa-tiktok social-tiktok`
      }
      return ''
    },
    formattedCount() {
      return this.count.toLocaleString()
    }
  }
}
</script>

<style scoped>
.source-with-count {
  display: inline-flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}
.icon {
  width: 12px;
  height: 12px;
}
</style>
